import { Globals } from '../_models/globals';
import { Component, OnInit } from '@angular/core';
import { User } from '../_models/user';
import { ApiIntegration } from '../_services/api.integration';
import { Router } from '@angular/router';
import { AccessSecurity } from '../_models/accessSecurity';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { environment } from '../../environments/environment';
import { AlertService } from '../_services/alert.service';
@Component({
  selector: 'app-admin-container',
  templateUrl: './admin-container.component.html',
  styleUrls: ['./admin-container.component.css']
})
export class AdminContainerComponent implements OnInit {
  activate = false;
  kycPopup: boolean = false;
  mouPopup: boolean = false;
  warehousePopup: boolean = false;
  addressPopup: boolean = false;
  channelPopup: boolean = false;
  shippingPopup: boolean = false;
  //kommunicateSettings: any = {};
  constructor(private alertService: AlertService, public accessSec: AccessSecurity, private api: ApiIntegration, private http: HttpClient, public g: Globals, public user: User, private router: Router) {
    document.getElementById('mainBody').className = '';
    this.fetchUserData();
  }

  ngOnInit() {
    //this.fetchUserData();

    /*       (function(d, m){
               this.kommunicateSettings = {"widgetcode":"25267dfa3d4c15ed0f6164f63e628624a439271c1efe32386b3ed69f547601dc6f76d66c84ee670641e1f7434c6db41724e228794fd31240521b81cfb18f3540","popupWidget":true,"automaticChatOpenOnNavigation":true};
               var s = document.createElement("script"); s.type = "text/javascript"; s.async = true;
               s.src = "https://salesiq.zoho.in/widget";
               var h = document.getElementsByTagName("script")[0]; h.appendChild(s);
               (window as any).zoho = m; m._globals = this.kommunicateSettings;
           })(document, (window as any).zoho || {});
           console.log("asd::" + this.kommunicateSettings);
           alert("asd::" + this.kommunicateSettings);
   */
  }

  fetchUserData() {
    if (this.user.role == undefined || this.user.role == '') {
      const promise = this.api.getUserData().toPromise();
      promise.then((data: any) => {
        this.user.role = data.role;
        this.user.accountOwnerId = data.accountOwnerId;
        this.user.userId = data.userId;
        this.user.userName = data.userName;
        this.user.sellerId = data.sellerId;
        this.user.orgUserId = data.orgUserId;
        this.user.logoURl = data.logoURl;
        this.user.organizationId = data.organizationId;
        this.user.duration = data.duration;
        this.user.loadedSampleData = data.loadedSampleData;
        if (data.role == 'ROLE_ADMIN') {
          this.user.adminUserId = data.userId;
        } else if (data.role == 'ACCOUNT_OWNER' || data.role == 'DEMO_ACCOUNT') {
          //this.router.navigate(['/admin/dashboard']);
          this.user.duration = data.duration;
          this.user.loadedSampleData = data.loadedSampleData;
          this.g.profilePopup = data['postRegData'];
          if (!this.g.profilePopup.isMOUDocPresent) {
            this.mouPopup = true;
          } else if (!this.g.profilePopup.isDefaultWHPresent) {
            this.warehousePopup = true;
          } else if (!this.g.profilePopup.isKYCVerified) {
            this.kycPopup = true;
          } else if (!this.g.profilePopup.isDefaultAddressPresent) {
            this.addressPopup = true;
          } else if (!this.g.profilePopup.isChannelPresent) {
            this.channelPopup = true;
          } else if (!this.g.profilePopup.isShippingLabelConfigured) {
            this.shippingPopup = true;
          }
        } else if (data.role == 'WORK_MEN' || data['role'] == 'PACKER') {
          this.router.navigate(['/admin/workMenOrder']);
          //this.assignSecurityValues(data['securityConfigs'], data['role']);
        } else if (data.role == 'SALES_MKTG' || data['role'] == 'CUSTOMER_CARE') {
          this.router.navigate(['/admin/customercareOrders']);
          //this.assignSecurityValues(data['securityConfigs'], data['role']);
        } else {
          this.assignSecurityValues(data['securityConfigs'], data['role']);
        }
        this.activate = true;
      }).catch((error) => {
        this.activate = true;
        console.log("Promise exception:");
      });
    } else {
      this.activate = true;
    }
  }

  logout() {
    this.user.role = "";
    this.user.accountOwnerId = null;
    this.user.userId = 0;
    this.user.adminUserId = 0;
    this.user.accountOwnerName = "";
    this.user.userName = "";
    this.user.organizationId = 0;
    this.user.token = null;
    this.router.navigate(['/access/login']);
  }

  switchToAdmin() {
    this.user.role = "ROLE_ADMIN";
    this.user.accountOwnerId = null;
    this.user.userId = this.user.adminUserId;
    this.router.navigate(['/admin/adminDashboard']);
  }

  toggleLeftMenu() {
    var classValue = document.getElementById('mainBody').className;
    if (classValue == '') {
      document.getElementById('mainBody').className = 'menu-close';
    } else {
      document.getElementById('mainBody').className = '';
    }
  }

  resetAccessSecurity() {
    for (let key of Object.keys(this.accessSec)) {
      this.accessSec[key] = false;
    }
  }

  assignSecurityValues(securityValues, role) {
    this.resetAccessSecurity();
    let securityConfigs = [];
    securityConfigs = securityValues;
    for (let sc of securityConfigs) {
      //Dashboard
      if (sc.securityCode == "view-dashboard") {
        this.accessSec.viewDashboard = true;
      }

      // outbound orders
      if (sc.securityCode == "create-order") {
        this.accessSec.createOrder = true;
      }
      if (sc.securityCode == "edit-order") {
        this.accessSec.editOrder = true;
      }
      if (sc.securityCode == "view-orders") {
        this.accessSec.viewOrders = true;
      }

      //Inventory

      if (sc.securityCode == "add-product") {
        this.accessSec.addProduct = true;
      }
      if (sc.securityCode == "edit-product") {
        this.accessSec.editProduct = true;
      }
      if (sc.securityCode == "delete-product") {
        this.accessSec.deleteProduct = true;
      }
      if (sc.securityCode == "view-products") {
        this.accessSec.viewProducts = true;
      }


      //workOrders
      if (sc.securityCode == "create-work-order") {
        this.accessSec.createWorkOrder = true;
      }

      if (sc.securityCode == "edit-work-order") {
        this.accessSec.editWorkOrder = true;
      }

      if (sc.securityCode == "view-work-orders") {
        this.accessSec.viewWorkOrders = true;
      }


      // inbound orders

      if (sc.securityCode == "create-inbound-order") {
        this.accessSec.createInboundOrder = true;
      }
      if (sc.securityCode == "edit-inbound-order") {
        this.accessSec.editInboundOrder = true;
      }
      if (sc.securityCode == "view-inbound-orders") {
        this.accessSec.viewInboundOrders = true;
      }
      if (sc.securityCode == "stock-transfer") {
        this.accessSec.stockTransfer = true;
      }

      //addressBook

      if (sc.securityCode == "create-customer") {
        this.accessSec.createCustomer = true;
      }
      if (sc.securityCode == "edit-customer") {
        this.accessSec.editCustomer = true;
      }
      if (sc.securityCode == "view-customers") {
        this.accessSec.viewCustomers = true;
      }


      //invoices

      if (sc.securityCode == "view-invoices") {
        this.accessSec.viewInvoices = true;
      }

      //reports

      if (sc.securityCode == "view-reports") {
        this.accessSec.viewReports = true;
      }

      //my account
      if (sc.securityCode == "view-settings") {
        this.accessSec.viewSettings = true;
      }
      if (sc.securityCode == "edit-settings") {
        this.accessSec.editSettings = true;
      }

      //settings
      if (sc.securityCode == "payment") {
        this.accessSec.payment = true;
      }
      if (sc.securityCode == "shipping-preferences") {
        this.accessSec.shippingPreferences = true;
      }
      if (sc.securityCode == "label-preferences") {
        this.accessSec.labelPreferences = true;
      }
      if (sc.securityCode == "return-preferences") {
        this.accessSec.returnPreferences = true;
      }


    }
  }

  loadData() {
    this.g.loaderDisplay = "display";
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/loadSampleData', {
      "demoAccountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('Data Uploaded', 'Successfully');
        } else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
